import {
  SalesCardV2,
  SalesCardV2StatsAndEvolution,
} from "@pharmupp/p3-front-commons"

interface PurchaseOtherCardProps {
  periodEndDate?: string | null
  mainStat: string
  evolution?: number
  onClick?: () => void
  tooltipMsg?: string
}

export const PurchaseOtherCard = ({
  periodEndDate,
  mainStat,
  evolution,
  onClick,
  tooltipMsg,
}: PurchaseOtherCardProps) => {
  return (
    <SalesCardV2
      title="Autres"
      period={periodEndDate}
      onClick={onClick}
      tooltipMsg={tooltipMsg}
    >
      <SalesCardV2StatsAndEvolution mainStat={mainStat} evol={evolution} />
    </SalesCardV2>
  )
}
